import { css } from "lit"

export const calloutFooterStyles = css`
  /* Callout footer */
  .callout-footer {
    display: grid;
    width: 100%;
    grid-row-gap: 3rem;
    grid-template-columns: 1.5rem 1fr 1.5rem;
    background: #4f645b;
    color: white;
    padding: 3rem 0;
  }

  .callout-image {
    display: none;
    background: rgba(200, 215, 209, .2);
    max-height: 280px;
    max-width: 200px;
  }

  .callout-content {
    display: grid;
    gap: 3rem;
    grid-column: 2;
  }

  .callout-image-wrapper {
    transform: translate(-8px, -8px);
  }

  .callout-sections {
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }

  .callout-title {
    font-size: 1.875rem;
    text-align: left;
  }

  .callout-section {
    display: flex;
    gap: 1.25rem;
  }

  .callout-section-content-text {
    display: flex;
    gap: 1rem;
    flex-direction: column;
    margin-bottom: 1.5rem;
  }

  .callout-section-icon {
    width: 1.5rem;
    height: 1.5rem;
  }

  .callout-section-title {
    font-size: 1.25rem;
    font-family: AvenirLTW01-65Medium, Avenir, sans-serif;
    font-weight: 500;
  }

  .callout-section-text {
    font-size: 0.875rem;
    line-height: 1.8;
    font-weight: 500;
  }

  .btn {
    display: inline-flex;
    align-items: center;
    padding: 0 1.5rem;
    background: #859e3b;
    color: white;
    height: 2.5rem;
    border-radius: 0.15rem;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 1px;
    line-height: 1.4;
    font-size: 0.68rem;
    font-weight: 700;
    transition: background 0.25s ease-out;
  }

  .btn:hover {
    background: #647a1c;
    text-decoration: none;
  }

  @media (min-width: 768px) {
    .callout-footer {
      grid-column-gap: 0.875rem;
      grid-template-columns: 1fr repeat(8, 70px) 1fr;
    }

    .callout-content {
      grid-column: 2 / -2;
    }

    .callout-section-content {
      width: 100%;
      display: flex;
    }

    .callout-title {
      text-align: center;
    }

    .btn {
      margin-left: auto;
    }
  }

  @media (min-width: 1024px) {
    .callout-footer {
      grid-column-gap: 12px;
      grid-template-columns: 1fr repeat(12, 70px) 1fr;
    }
  }

  @media (min-width: 1280px) {
    .callout-footer {
      align-items: center;
    }

    .callout-content {
      padding: 3.5rem 0;
      align-content: start;
      display: flex;
      flex-wrap: wrap;
      grid-column: 5 / -2;
    }

    .callout-image {
      display: initial;
      grid-column: 2 / span 3;
      margin-right: 1.25rem;
      margin-top: 0.5rem;
    }

    .callout-sections {
      flex-direction: row;
    }

    .callout-section-content {
      display: initial;
    }

    .callout-title {
      flex-basis: 100%;
    }
  }

  @media (min-width: 1440px) {
    .callout-footer {
      grid-template-columns: 1fr repeat(16, 70px) 1fr;
    }

    .callout-content {
      grid-column: 7 / -2;
    }

    .callout-image {
      grid-column: 4 / span 3;
    }
`
